import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/** Diárias futuras de reservas avulsas que usam saldo deste plano de creche. */
export async function fetchLinkedFutureDaysCount(contractId: string): Promise<number> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data, error } = await (supabase as any).rpc("count_daycare_plan_linked_future_days", {
    p_contract_id: contractId,
  });
  if (error) throw error;
  return Number(data ?? 0);
}

export function useLinkedFutureDaysCount(contractId: string, enabled: boolean): UseQueryResult<number> {
  return useQuery({
    queryKey: ["stay-plan-contracts", "linked-future-days", contractId],
    queryFn: () => fetchLinkedFutureDaysCount(contractId),
    enabled,
  });
}
